import { HtmlGraphicObject } from "../html/html-graphic-object.js";
import { createSvgAndSvgObjects } from "../utils/create-svg.js";
import { NamedObjectContainer, SingleNamedObject } from "../named-object-container.js";

export class SvgRootRectangle extends HtmlGraphicObject {
  constructor(settings) {
    super(settings);
    this.settings.htmlObject.wrapper = document.createElement("div");
    this.settings.htmlObject.wrapper.setAttribute("id", `wrapper_${this.settings.id}`);
    this.settings.htmlObject.wrapper.setAttribute(
      "style",
      `left: ${this.settings.htmlObject.absoluteLocation.x}px; top: ${this.settings.htmlObject.absoluteLocation.y}px; width: ${this.settings.htmlObject.sizeInPixels.width}px; height: ${this.settings.htmlObject.sizeInPixels.height}px; margin: 0px; position: absolute; background-color: transparent; overflow: hidden;`
    );

    this.settings.htmlObject.ref = createSvgAndSvgObjects(
      "svg",
      ["class", this.settings.id],
      ["x", `0px`],
      ["y", `0px`],
      ["min-width", `${this.settings.htmlObject.sizeInPixels.width}px`],
      ["width", `${this.settings.htmlObject.sizeInPixels.width}px`],
      ["height", `${this.settings.htmlObject.sizeInPixels.height}px`]
    );
    this.settings.htmlObject.ref.style.position = "absolute";
    //this.settings.htmlObject.ref.style.border = "1px solid black";
    //this.settings.htmlObject.ref.style.border = "1px solid magenta";

    //let defs = createSvgAndSvgObjects("defs");
    //this.settings.htmlObject.ref.appendChild(defs);

    this.settings.htmlObject.wrapper.appendChild(this.settings.htmlObject.ref);
    this.settings.htmlObject.parent.ref.appendChild(this.settings.htmlObject.wrapper);

    this.childItemsContainer = new NamedObjectContainer("Items");
  }

  addItem(name, htmlGraphicChildObject) {
    this.childItemsContainer.add(new SingleNamedObject(name, htmlGraphicChildObject));
  }

  createHtmlBorders() {
    super.createHtmlBorders();
    this.settings.htmlObject.ref.style.minWidth = `${this.settings.htmlObject.sizeInPixels.width}px`;
    this.settings.htmlObject.ref.style.width = `${this.settings.htmlObject.sizeInPixels.width}px`;
    this.settings.htmlObject.ref.style.height = `${this.settings.htmlObject.sizeInPixels.height}px`;
    this.settings.htmlObject.wrapper.style.left = `${this.settings.htmlObject.absoluteLocation.x}px`;
    this.settings.htmlObject.wrapper.style.top = `${this.settings.htmlObject.absoluteLocation.y}px`;
    this.settings.htmlObject.wrapper.style.width = `${this.settings.htmlObject.sizeInPixels.width}px`;
    this.settings.htmlObject.wrapper.style.height = `${this.settings.htmlObject.sizeInPixels.height}px`;
  }

  createBorders() {
    super.createBorders();
    this.childItemsContainer.forEach(item => {
      item.setParentSize(this.settings.sizeInPixels.width, this.settings.sizeInPixels.height);
      item.createBorders();
    });
  }

  setDebugMode(debugSettings) {
    super.setDebugMode(debugSettings);
    this.childItemsContainer.forEach(item => {
      item.setDebugMode(debugSettings);
    });
  }
}
